// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DynProperty } from "../../Commons/DynProperty.ts";
import { MathUtils } from "../../Utils/MathUtils.ts";
import { QuickTableEditingInfo } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.ts";


export let AlgorithmMarketConsensusPanelItem = function (item, isLong, instrument, color, settings)
{
    BaseItem.call(this, settings);

    this.Instrument = instrument;
    this.IsLong = isLong;
    this.Color = color;

    if (instrument)
        this.Name = instrument.DisplayName();

    if (item)
    {
        if (!instrument)
            this.Name = item.InstrumentName;

        this.Value = item.Percent;
        this.IsExpertChoice = item.IsExpertChoice;
    }

    this.QuickTableEditingInfoMap[0] = (function ()
    {
        return new QuickTableEditingInfo(DynProperty.MARKET_CONSENSUS);
    })();
};

AlgorithmMarketConsensusPanelItem.prototype = Object.create(BaseItem.prototype);

AlgorithmMarketConsensusPanelItem.prototype.ColumnCount = function ()
{
    return AlgorithmMarketConsensusPanelItem.columnsParams.length
};

AlgorithmMarketConsensusPanelItem.prototype.GetCurrentInstrument = function ()
{
    return this.Instrument;
};

AlgorithmMarketConsensusPanelItem.prototype.UpdateItemData = function (item, color)
{
    if (item)
    {
        if (!this.Instrument)
            this.Name = item.InstrumentName;

        this.Value = item.Percent;
        this.isNeedFireUpdate = this.IsExpertChoice !== item.IsExpertChoice
        this.IsExpertChoice = item.IsExpertChoice;
    }
    this.isNeedFireUpdate = this.isNeedFireUpdate || this.Color !== color
    this.Color = color;
};

AlgorithmMarketConsensusPanelItem.prototype.InstrumentName = function (saveMode)
{
    return this.Instrument.GetInteriorID(saveMode);
};

AlgorithmMarketConsensusPanelItem.prototype.getColumnData = function (column)
{
    let value = this.getColumnValue(column);
    let formattedValue = '';
    let tooltip = this.IsExpertChoice ? AlgorithmMarketConsensusPanelItem.Tooltip : null;

    switch (column)
    {
        case 0:
            if (value)
                formattedValue = {
                    IsLong: this.IsLong,
                    Value: MathUtils.TruncateDouble(this.Value, 2),
                    Name: this.Name,
                    IsExpertChoice: this.IsExpertChoice,
                    tooltip: tooltip,
                    Color: this.Color
                };
            break;

        default:
            formattedValue = null;
    }

    return { Value: value, FormattedValue: formattedValue };
};

AlgorithmMarketConsensusPanelItem.prototype.getColumnValue = function (column)
{
    switch (column)
    {
        case 0:
            return this.Name + this.Value;
            break;

        default:
            return null;
    }
};

AlgorithmMarketConsensusPanelItem.prototype.GetColumnParams = function (column)
{
    let result = AlgorithmMarketConsensusPanelItem.columnsParams[column];
    return result
};

AlgorithmMarketConsensusPanelItem.columnsParams = [
    new ColumnParams("panel.AlgorithmMarketConsensusPanel.TopLong", 100, 0, false, true, false)
];

AlgorithmMarketConsensusPanelItem.ListMenuIndex = [
    "panel.AlgorithmMarketConsensusPanel.TopLong"
];

AlgorithmMarketConsensusPanelItem.Tooltip = "Expert choice";